(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hs-system"] && !Shopify.designMode) return;
  try {
    (() => {
  const closeMenus = (except) => document.querySelectorAll('.hs-header details[open]').forEach(menu => { if (menu !== except && !menu.contains(except)) menu.open = false; });
  document.addEventListener('click', event => {
    const summary = event.target.closest('.hs-header summary');
    if (summary) closeMenus(summary.parentElement);
    else if (!event.target.closest('.hs-header')) closeMenus();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const opened = document.querySelector('.hs-header details[open]');
    if (opened) { opened.open = false; opened.querySelector('summary').focus(); }
  });
  document.querySelectorAll('.hs-catalog-tabs a').forEach(link => {
    if (new URL(link.href).pathname === location.pathname) link.setAttribute('aria-current', 'page');
  });
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-hs-minimum]');
    if (!input) return;
    const value = Number(input.value), minimum = Number(input.dataset.hsMinimum);
    if ((input.dataset.hsCart && value === 0) || (Number.isInteger(value) && value >= minimum)) { input.setCustomValidity(''); return; }
    input.value = String(minimum);
    input.setCustomValidity(input.dataset.hsMessage);
    input.reportValidity();
    setTimeout(() => input.setCustomValidity(''), 1800);
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const inputs = Array.from(form.elements).filter(input => input.matches && input.matches('[data-hs-minimum]'));
    const invalid = inputs.find(input => {
      const value = Number(input.value);
      return !(input.dataset.hsCart && value === 0) && (!Number.isInteger(value) || value < Number(input.dataset.hsMinimum));
    });
    if (invalid) { event.preventDefault(); event.stopImmediatePropagation(); invalid.setCustomValidity(invalid.dataset.hsMessage); invalid.reportValidity(); }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
